import { ThemeProvider } from 'next-themes';

import { ColorModeProviderProps } from './types/ColorModeProviderProps';

export function ColorModeProvider(props: ColorModeProviderProps) {
  return (
    <ThemeProvider attribute="class" disableTransitionOnChange {...props} />
  );
}
